import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup, FormControl } from "react-bootstrap";
import "./ViewHistory.css";
import TicketsTable from "../../components/Employee/Employee_ManageTicket/TicketsTable";
import Pagination from "../../components/Employee/Employee_ManageTicket/Pagination";
import { getAllTicket } from "../../services/employeeServices";
import { useSelector } from "react-redux";

const ViewHistory = () => {
  const user = useSelector((state) => state.user);
  const stationaryId = useSelector((state) => state.user.stationaryId);

  const [licensePlate, setLicensePlate] = useState("");
  const [data, setData] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [inArea, setIn] = useState(true);
  const [outArea, setOut] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [ticketsPerPage] = useState(6);

  const fetchTickets = async () => {
    try {
      const response = await getAllTicket(stationaryId);
      if (response && response.DT) {
        setData(response.DT);
      }
    } catch (error) {
      console.error("Error at fetchTickets in ViewHistory:", error);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const ticketsToPaginate = filteredTickets.length > 0 ? filteredTickets : data;

  const formattedTickets = ticketsToPaginate.map((ticket) => ({
    id: ticket.id || ticket._id,
    licensePlate:
      ticket.licensePlate ||
      ticket.Vehicle?.license_plate ||
      ticket.vehicle?.plate ||
      "N/A",
    owner: ticket.userCode || ticket.owner || "Khách vãng lai",
    parkingLot: ticket.parkingLotName || "Bãi đỗ chính",
    checkInTime: ticket.timeIn
      ? new Date(ticket.timeIn).toLocaleString("vi-VN")
      : new Date(ticket.createdAt).toLocaleString("vi-VN"),
    checkOutTime: ticket.timeOut
      ? new Date(ticket.timeOut).toLocaleString("vi-VN")
      : ticket.updatedAt && new Date(ticket.updatedAt).getTime() !== new Date(ticket.createdAt).getTime()
      ? new Date(ticket.updatedAt).toLocaleString("vi-VN")
      : "Đang trong bãi",
    isInArea: !ticket.timeOut && (!ticket.updatedAt || new Date(ticket.updatedAt).getTime() === new Date(ticket.createdAt).getTime())
  }));

  const indexOfLastTicket = currentPage * ticketsPerPage;
  const indexOfFirstTicket = indexOfLastTicket - ticketsPerPage;
  const currentTickets = formattedTickets.slice(
    indexOfFirstTicket,
    indexOfLastTicket
  );

  const paginate = (pageNumber) => {
    if (
      pageNumber > 0 &&
      pageNumber <= Math.ceil(formattedTickets.length / ticketsPerPage)
    ) {
      setCurrentPage(pageNumber);
    }
  };

  // Filter Logic
  useEffect(() => {
    let filtered = [...data];

    if (licensePlate.trim() !== "") {
      filtered = filtered.filter((ticket) => {
        const plate =
          ticket.licensePlate ||
          ticket.Vehicle?.license_plate ||
          ticket.vehicle?.plate ||
          "";
        return plate.toLowerCase().includes(licensePlate.trim().toLowerCase());
      });
    }

    if (inArea && !outArea) {
      filtered = filtered.filter(
        (ticket) => !ticket.timeOut
      );
    } else if (!inArea && outArea) {
      filtered = filtered.filter(
        (ticket) => ticket.timeOut
      );
    } else if (!inArea && !outArea) {
      filtered = [];
    }

    setFilteredTickets(filtered);
    setCurrentPage(1);
  }, [data, licensePlate, inArea, outArea]);

  return (
    <div className="view-history-page py-4">
      <div className="container">
        {/* Page Header */}
        <div className="page-header-card mb-4 p-4 rounded-4 shadow-sm bg-white border d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div>
            <h3 className="fw-bold text-dark mb-1 d-flex align-items-center gap-2">
              <i className="bi bi-clock-history text-primary"></i>
              Lịch sử xe ra vào bãi đỗ
            </h3>
            <p className="text-muted mb-0 small">
              Quản lý, tra cứu và giám sát chi tiết lượt xe ra vào trong hệ thống SmartPark
            </p>
          </div>
          <div className="d-flex align-items-center gap-2">
            <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill fw-semibold">
              Tổng số lượt: {data.length}
            </span>
          </div>
        </div>

        {/* Main Content Card */}
        <div className="card shadow-sm border-0 rounded-4 overflow-hidden">
          <div className="card-header bg-white border-bottom p-3 p-md-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
            {/* Search Box */}
            <div className="search-box flex-grow-1" style={{ maxWidth: "380px" }}>
              <InputGroup>
                <InputGroup.Text className="bg-light border-end-0">
                  <i className="bi bi-search text-muted"></i>
                </InputGroup.Text>
                <FormControl
                  type="text"
                  value={licensePlate}
                  onChange={(e) => setLicensePlate(e.target.value)}
                  placeholder="Nhập biển số xe tìm kiếm..."
                  className="bg-light border-start-0 ps-0"
                />
                {licensePlate && (
                  <Button
                    variant="light"
                    className="border"
                    onClick={() => setLicensePlate("")}
                  >
                    <i className="bi bi-x"></i>
                  </Button>
                )}
              </InputGroup>
            </div>

            {/* Filter Switches */}
            <div className="d-flex align-items-center gap-3 bg-light px-3 py-2 rounded-3 border">
              <span className="fw-semibold text-secondary small">Trạng thái:</span>
              <div className="form-check form-switch mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="inAreaSwitch"
                  checked={inArea}
                  onChange={() => setIn(!inArea)}
                />
                <label className="form-check-label small fw-medium text-dark ms-1" htmlFor="inAreaSwitch">
                  Đang trong bãi
                </label>
              </div>
              <div className="form-check form-switch mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="outAreaSwitch"
                  checked={outArea}
                  onChange={() => setOut(!outArea)}
                />
                <label className="form-check-label small fw-medium text-dark ms-1" htmlFor="outAreaSwitch">
                  Đã ra ngoài
                </label>
              </div>
            </div>
          </div>

          <div className="card-body p-0">
            <TicketsTable
              data={currentTickets}
              startIndex={indexOfFirstTicket}
            />
          </div>

          {/* Footer Pagination */}
          <div className="card-footer bg-white border-top p-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
            <div className="text-muted small">
              Hiển thị <b>{currentTickets.length}</b> / <b>{ticketsToPaginate.length}</b> phiếu
            </div>
            <Pagination
              ticketsPerPage={ticketsPerPage}
              totalTickets={ticketsToPaginate.length}
              paginate={paginate}
              currentPage={currentPage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewHistory;
